import type { IssueId } from '@atlassian/jira-shared-types';
import { EXPLICIT } from '@atlassian/jira-software-roadmap-timeline-table-kit';
import type { OverlayItem } from '@atlassian/jira-software-roadmap-timeline-table-kit/src/types';
import type { IssuesMap } from '../../../../common/utils/use-issues-map';
import type { TimelineViewIssue } from '../../../../services/get-timeline-view-issues/types';

// converts timeline issue to a flyout item
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
export const getOverlayIssueItem = (issue?: TimelineViewIssue): OverlayItem | void =>
	issue && {
		id: issue.issueId,
		itemKey: issue.key,
		title: issue.summary || '',
		typeName: issue.issueType.name,
		iconUrl: issue.issueType.iconUrl,
		startDateType: EXPLICIT,
		startDate: issue.startDate,
		dueDateType: EXPLICIT,
		dueDate: issue.dueDate,
		isHidden: false,
		intervalName: undefined,
		warningMessages: [],
	};

export const getIssueFromMap = (issueId: string | number, issuesMap: IssuesMap) =>
	// TODO: JEH-21 convert "issueMap" to <number, TimelineViewIssue>
	// @ts-expect-error - TS2345 - Argument of type 'string | number' is not assignable to parameter of type 'string'.
	issuesMap.get(issueId) || issuesMap.get(`${issueId}`);

// gets dependency/dependee data to render inside a flyout
export const getDepsItem = ({
	issuesMap,
	issueIds,
}: {
	issueIds: IssueId[];
	issuesMap: IssuesMap;
}) =>
	issueIds
		.map((issueId: IssueId) => getOverlayIssueItem(getIssueFromMap(Number(issueId), issuesMap)))
		.filter(Boolean);
